import { ApiAuthUser } from "@incendium/api";
import { userService } from "Apis";

export const saveUser = async (user: ApiAuthUser) => {
  const isUpdate = !!user.id && user.id !== "" && user.id !== "new";
  const payload = {
    user: {
      ...user,
      id: isUpdate ? user.id : undefined,
    },
  };

  const fn = isUpdate
    ? userService.userServiceUpdateUser({
      userId: user.id!,
      body: payload,
    })
    : userService.userServiceCreateUser({
      body: payload,
    });

  return await fn;
};

export const listAllUsers = async () => {
  const res = await userService.userServiceListUsers();
  return res.result || [];
};

export const listProjectUsers = async (projectId: number) => {
  const res = await userService.userServiceListProjectUsers({
    projectId,
  });
  return res.result || [];
};

export const deleteUser = async (userId: string) => {
  await userService.userServiceDeleteUser({ userId });
  return true;
};
